



























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class DialogLoad extends Vue {
  // State
  @Prop() dialog: boolean;
  dialogSwitch: boolean = false;

  @Watch('dialog')
  onDialogChanged(value: boolean, lastValue: boolean) {
    this.dialogSwitch = value;
  }

  closeDialog() {
    console.log('Entrée');
    this.$emit('update_dialog', false);
  }
}
